import React from "react";
import styled from "styled-components"
import { breakPoint } from "../styleUtils";

const Wrapper = styled.div`
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;

    ${breakPoint('xs')` max-width: 100%;`}
    ${breakPoint('sm')` max-width: 100%;`}
    ${breakPoint('md')` max-width: 768px;`}
    ${breakPoint('lg')` max-width: 992px;`}
    ${breakPoint('xl')` max-width: 1200px;`}

`

export default function ContentWrapper ({
    children
}: {
    children: JSX.Element|JSX.Element[]
}) {
    return (
        <Wrapper>
            {children}
        </Wrapper>
    )
}